export default [
  {
    description: 'Floating Bug Tab GECX',
    control: '2880-20',
    treatment: '2880-21',
    ks: 'aiFloatingActionButtonEnabled',
    devices: ['Desktop', 'Mobile'],
    invalidationPrefetch: false,
    clientSide: true,
  },
  {
    description: 'Enabled Gray Search Bar Prominence',
    control: '3244-20',
    treatment: '3244-21',
    ks: 'graySearchBarProminenceEnabled',
    devices: ['Desktop', 'Mobile'],
    invalidationPrefetch: false,
  },
  {
    description: 'Ask Macys Prompts',
    control: '3233-20',
    treatment: '3233-21',
    ks: 'askMacysPromptsEnabled',
    arm: 'askMacysPromptsArmOne',
    devices: ['Desktop', 'Mobile'],
    invalidationPrefetch: false,
    clientSide: true,
  },
  {
    description: 'Ask Macys Prompts',
    control: '3233-20',
    treatment: '3233-22',
    ks: 'askMacysPromptsEnabled',
    arm: 'askMacysPromptsArmTwo',
    devices: ['Desktop', 'Mobile'],
    invalidationPrefetch: false,
    clientSide: true,
  },
];
